import React, { useEffect, useState } from "react";
import Shopsubbanner from "../../components/shopsubbanner";
import ProductGrid from "../../components/ProductGrid";

const Premia = ({ products, loading, error }) => {
  const [bannerImage, setBannerImage] = useState(
    "https://res.cloudinary.com/dtivafy25/image/upload/v1753963088/Derby_04_xpr919.jpg" // Desktop
  );

  useEffect(() => {
    window.scrollTo(0, 0);

    const updateBanner = () => {
      if (window.innerWidth <= 768) {
        // Mobile banner
        setBannerImage("https://res.cloudinary.com/dtivafy25/image/upload/v1754651193/02_by6vd5.jpg");
      } else {
        // Desktop banner
        setBannerImage("https://res.cloudinary.com/dtivafy25/image/upload/v1753963088/Derby_04_xpr919.jpg");
      }
    };

    updateBanner(); // Run on mount
    window.addEventListener("resize", updateBanner);

    return () => {
      window.removeEventListener("resize", updateBanner);
    };
  }, []);

  return (
    <>
      <Shopsubbanner image_url={bannerImage} />
      <ProductGrid category="Premia" products={products} loading={loading} error={error} />
    </>
  );
};

export default Premia;
